export default __webpack_public_path__ + "static/media/cabinet1-before-1920w.ab22b2e6.png";